import(/* webpackMode: "eager" */ "/codebuild/output/src3001039359/src/core-admin-app/src/app/login/page.js");
